import { http } from "services/http";
import qs from "qs";

export const getUserEmploymentById = async (employmentId) => {
  try {
    const response = await http.get(
      `/user/get_employment_row?employment_id=${employmentId}`
    );
    return response.data.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const saveUserEmployment = async (employment) => {
  const options = {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  };
  try {
    const response = await http.post(
      `/user/save_user_employment/0`,
      qs.stringify(employment),
      options
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getUserOrganizationPermissions = async () => {
  try {
    const response = await http.get(`/user/get_director_permissions`);
    return response.data.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getUserLogs = async (userId) => {
  try {
    const response = await http.get(`/api/users/user_logs?user_id=${userId}`)
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
}
